/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import dayjs from 'dayjs';
import { IHospital } from 'app/shared/model/hospital.model';
import { InOutType } from 'app/shared/model/enumerations/in-out-type.model';

export interface ICashTransaction {
  id?: string;
  inOutType?: keyof typeof InOutType | null;
  tenderedAmount?: number | null;
  qty1?: number | null;
  qty2?: number | null;
  qty5?: number | null;
  qty10?: number | null;
  qty20?: number | null;
  qty50?: number | null;
  qty100?: number | null;
  qty200?: number | null;
  qty500?: number | null;
  qty1000?: number | null;
  qty2000?: number | null;
  active?: boolean | null;
  microSec?: dayjs.Dayjs | null;
  timestampEntry?: dayjs.Dayjs | null;
  lastUpdated?: dayjs.Dayjs | null;
  cursor?: number;
  hospital?: IHospital | null;
}

export const defaultValue: Readonly<ICashTransaction> = {
  active: false,
};
